var AbortablePromise = /** @class */ (function () {
    function AbortablePromise(arg) {
        var _this = this;
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        if (typeof arg === 'function') {
            this.promise = new Promise(function (resolve, reject) {
                _this.signal.addEventListener('abort', function () { return reject(new Error('Promise aborted')); });
                arg(resolve, reject, _this.signal);
            });
        }
        else if (arg instanceof Promise) {
            this.promise = new Promise(function (resolve, reject) {
                _this.signal.addEventListener('abort', function () { return reject(new Error('Promise aborted')); });
                arg.then(resolve, reject);
            });
        }
        else {
            throw new TypeError('Invalid argument to AbortablePromise constructor');
        }
    }
    AbortablePromise.prototype.abort = function () {
        this.controller.abort();
    };
    AbortablePromise.prototype.then = function (onfulfilled, onrejected) {
        var newPromise = this.promise.then(onfulfilled, onrejected);
        return new AbortablePromise(newPromise);
    };
    AbortablePromise.prototype.catch = function (onrejected) {
        var newPromise = this.promise.catch(onrejected);
        return new AbortablePromise(newPromise);
    };
    AbortablePromise.prototype.finally = function (onfinally) {
        var newPromise = this.promise.finally(onfinally);
        return new AbortablePromise(newPromise);
    };
    AbortablePromise.all = function (promises) {
        var abortControllers = promises.map(function (p) { return p.controller; });
        var allPromise = Promise.all(promises.map(function (p) { return p.promise; }));
        var wrappedPromise = new AbortablePromise(function (resolve, reject, signal) {
            var onAbort = function () { return reject(new Error('Promise aborted')); };
            signal.addEventListener('abort', onAbort);
            abortControllers.forEach(function (controller) { return controller.signal.addEventListener('abort', onAbort); });
            allPromise.then(resolve, reject).finally(function () {
                signal.removeEventListener('abort', onAbort);
                abortControllers.forEach(function (controller) { return controller.signal.removeEventListener('abort', onAbort); });
            });
        });
        return wrappedPromise;
    };
    return AbortablePromise;
}());

export { AbortablePromise as default };
